module.exports = __webpack_public_path__ + "static/img/costaTop.d6e1645.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/costaTop.png
// module id = aj/g
// module chunks = 2